import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProviderExchangeItems } from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"
import ProviderExchangeItemsList from "components/ProviderDashboard/ProviderItems/ProviderExchangeItemsList"

const ProviderExchangeItems = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
  }
  const ProviderExchangeItems = useSelector(
    state => state.providerDashboard.ProviderExchangeItems
  )

  // get exchange distributions based params
  useEffect(() => {
    dispatch(getProviderExchangeItems(getParams))

    return () => {
      dispatch(providerDashboardAction.resetProviderExchangeItems())
    }
  }, [])

  return (
    // Provider Exchange Item list components
    <ProviderExchangeItemsList
      data={ProviderExchangeItems?.data?.data}
      loading={ProviderExchangeItems?.loading}
    />
  )
}

export default ProviderExchangeItems
